const isLatLngLiteral = (latLng) => typeof latLng.lat === 'number';
/** Converts a Google Maps position (a `LatLng` object or a plain literal) to `GeoCoordinates`. */
export const toGeoCoordinates = (latLng) => isLatLngLiteral(latLng)
    ? { latitude: latLng.lat, longitude: latLng.lng }
    : { latitude: latLng.lat(), longitude: latLng.lng() };
